module.exports = __webpack_public_path__ + "files/3e9d7381e6ed348d2ec7bc018919de1e.png";